module.exports = __webpack_public_path__ + "static/media/gallery-1.7c5c8f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laika/gallery-1.jpg
// module id = 4227
// module chunks = 14